import React from 'react';

const WhereWeLend = () => {
  return (
    <section data-testid="where-we-lend-section" className="py-24 bg-slate-900 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto">
          {/* Left Content */}
          <div className="relative">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
              Where We Lend
            </h2>
            {/* Decorative dot */}
            <div className="absolute -top-2 -left-4 w-5 h-5 bg-blue-400 rounded-full opacity-60"></div>
            <p className="text-lg text-gray-300 leading-relaxed">
              <span className="text-blue-400 font-semibold">Nationwide coverage</span> across the United States. We are committed to helping real estate investors succeed in markets across the country.
            </p>
            <p className="text-gray-400 mt-4 text-sm">
              Contact us to discuss financing options in your area.
            </p>
          </div>

          {/* Right - US Map Image */}
          <div className="relative">
            <img
              src="https://customer-assets.emergentagent.com/job_130b504f-d356-4ffc-9f88-b9ceecab1da1/artifacts/9gfx8f4h_US%20Map%20PNG.png"
              alt="Close Now Lending nationwide lending coverage - We lend across all 50 states for hard money, fix and flip, DSCR, and commercial real estate loans"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhereWeLend;
